import { CreditCard, Package, Truck, User } from 'lucide-react'

import { StepByStepGuideStep } from '../../shared/components/StepByStepGuide/StepByStepGuide.types'
import { TestimonialData } from './Send.types'

export const sendPageDictionary = {
  heroTitle: 'Ship to Your Customers for Less',
  heroSubtitle:
    'Send products to your customers worldwide using trusted travelers as couriers. Save up to 60% on international shipping.',
  howItWorksLink: 'How It Works - Send with Hurrier',
  startShippingButton: 'Start Shipping'
}

export const howItWorksSection = {
  title: 'How It Works',
  subtitle: 'In 4 simple steps, you can have your packages at your door.',
  steps: [
    {
      icon: <Package size={40} color="#6D28D9" />,
      title: 'Add Your Items',
      description: 'Upload photos and details of the products you need to ship.'
    },
    {
      icon: <User size={40} color="#6D28D9" />,
      title: 'Add Recipient Details',
      description: "Enter your customer's delivery address and contact information."
    },
    {
      icon: <CreditCard size={40} color="#6D28D9" />,
      title: 'Pay & Submit',
      description: "Review your order, pay securely, and we'll match you with a traveler."
    },
    {
      icon: <Truck size={40} color="#6D28D9" />,
      title: 'We Handle Delivery',
      description: 'A verified traveler carries your package and delivers it to your customer.'
    }
  ] as StepByStepGuideStep[]
}

export const testimonialData: TestimonialData = {
  quote:
    'Hurrier cut my shipping costs by more than half. I send products to customers in Kingston every week and they arrive faster than traditional freight.',
  authorName: 'Sarah Johnson',
  authorTitle: 'Small Business Owner',
  imageUrl:
    'https://images.unsplash.com/photo-1631010231130-5c7828d9a3a7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=800&q=80',
  stats: [
    { icon: 'percent', value: '60%', label: 'Avg. Savings' },
    { icon: 'clock', value: '3-5 Days', label: 'Delivery Time' },
    { icon: 'star', value: '4.9/5', label: 'Customer Rating' }
  ]
}
